module.exports = ".centered {\n  text-align: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/create-application/sdai-form/sdai/sdai.component.css
// module id = ./src/app/create-application/sdai-form/sdai/sdai.component.css
// module chunks = main